import { ArrowCircleRight, Check } from "@phosphor-icons/react";
import { useState } from "react";
import { Link } from "react-router-dom";

import {
  ManageSubscriptionDialog,
  SubscriptionPlanIcon,
} from "features/subscriptions/components";

import DottedSeparator from "common/components/DottedSeparator";
import Alert from "common/components/ui/Alert";
import { Button } from "common/components/ui/Button";

const features = [
  "Slack onboarding",
  "Full whitelabel",
  "Team collaboration",
  "Profile migration assistance",
];

export default function GetAgencyPlan() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="p-1.5 bg-whiteGray rounded-4xl">
        <div className="flex border border-black-200 rounded-4xl">
          {/*left section*/}
          <div className="flex flex-col w-96 pl-7 pr-8 pt-9 pb-8 bg-white rounded-l-4xl">
            <div className="gap-x-4 flex mb-9">
              <SubscriptionPlanIcon size="md" plan="agency" />
              <h2 className="text-xl-bold">Get started with our Agency Plan</h2>
            </div>
            <div className="flex flex-col gap-y-2">
              {features.map((feature) => (
                <div key={feature} className="flex gap-x-2 items-center">
                  <Check className="text-green-600" />
                  <span className="text-xs-medium">{feature}</span>
                </div>
              ))}
            </div>
            <DottedSeparator className="my-5" />
            <Alert className="mb-9" variant="gradient">
              The Agency Plan gives you a large pool of seats that can be
              assigned to any workspaces that do not have an active LinkedIn
              Seat subscription
            </Alert>
            <div className="gap-x-2 flex ml-auto mt-9">
              <Button asChild variant="secondary-black" size="sm">
                <Link
                  target="_blank"
                  to="https://help.aimfox.com/en/articles/13408843-aimfox-agency-plan"
                >
                  Learn more
                </Link>
              </Button>
              <Button
                size="sm"
                rightIcon={<ArrowCircleRight weight="fill" />}
                onClick={() => setIsOpen(true)}
              >
                Upgrade
              </Button>
            </div>
          </div>
          {/*right section*/}
          <div className="flex-1 rounded-r-4xl bg-[url(/images/plans/agency-bg.webp)] bg-cover" />
        </div>
      </div>
      <ManageSubscriptionDialog
        plan="agency"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
    </>
  );
}
